export default __webpack_public_path__ + "795d8dc09f387549eabe15ee67cd0f24.png";